/**
 * Created by zhaoyao on 19:45.
 * 充值详情界面
 */
import React from 'react';
import {Divider, Button} from "antd";
import {fetchGet} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

class AddressBook extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeDetail',
            data:{

            },
            IMEI:this.props.match.params.IMEI
        };
    }


    componentDidMount(){

    }

    render(){

        return <div className="padding_15">
                <div className="flex_row margin_top_20" style={{fontSize: '3px', color: '#3db1af'}}>
                    添加到通讯录的成员才能给宝贝打电话，确保宝贝不会被陌生来电骚扰
                </div>
               <Divider />
                <div className="flex_row" style={{fontSize: '3px', color: '#3db1af'}}>
                    {this.state.data.assignStatus==null?("你的通讯录是空的，添加联系人让更多家人和孩子保持联络"):("充值成功")}
                </div>
            <Divider />
            <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                                    onClick={this.onNextClick}>添加新联系人</Button>

        </div>
    }

    onNextClick = () => {
        const {IMEI } = this.state;
        this.props.history.push('/AddressBookAdd/'+IMEI);

    }
}

export  default AddressBook;